import { useEffect, useState } from "react";

import { Alert } from "@consumidor-positivo/aurora";

import classNames from "classnames";

import "./styles.scss";

type ToastProps = {
	title: string;
	type: "success" | "error";
	duration?: number;
	onClose?: () => void;
	absolutePosition?: boolean;
};

export const Toast = ({
	duration = 4000,
	onClose,
	title,
	type,
	absolutePosition,
}: ToastProps) => {
	const [visible, setVisible] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			handleClose();
		}, duration);

		return () => clearTimeout(timer);
	}, [duration]);

	const handleClose = () => {
		setVisible(false);
		onClose?.();
	};

	const toastClassNames = classNames("toast", {
		"toast--absolute": absolutePosition,
	});

	if (!visible) return null;

	return (
		<div className={toastClassNames}>
			<Alert
				status={type}
				title={{ content: title }}
				closeButton
				onCloseButton={handleClose}
			/>
		</div>
	);
};
